import { createSlice } from "@reduxjs/toolkit";
import {
  getWorkshopsService,
  getWorkshopByIdService,
  getTagsService,
  createWorkshopService
} from "../services/workshops_service";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  workshopsList: [],
  metaWorkshops: null,
  workshopInfo: null,
  tagsList: [],
  metaTags: null,
  isLoadingAction:false
};

const slice = createSlice({
  name: "workshops",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // GET ALL WORKSHOPS
      .addCase(getWorkshopsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.workshopsList = action.payload?.data?.data;
        state.metaWorkshops = action.payload?.data?.meta?.meta;
      })
      .addCase(getWorkshopsService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getWorkshopsService.pending, (state) => {
        state.isLoading = true;
      })

      // GET WORKSHOP BY ID
      .addCase(getWorkshopByIdService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.workshopInfo = action.payload?.data?.data;
      })
      .addCase(getWorkshopByIdService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getWorkshopByIdService.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTagsService.fulfilled, (state, action) => {
        state.isLoading = false;
        state.tagsList = action.payload?.data?.data;
        state.metaTags = action.payload?.data?.meta?.meta;
      })
      .addCase(getTagsService.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(getTagsService.pending, (state) => {
        state.isLoading = true;
      }).addCase(createWorkshopService.fulfilled, (state, action) => {
        state.isLoadingAction = false;
   
      })
      .addCase(createWorkshopService.rejected, (state) => {
        state.isLoadingAction = false;
      })
      .addCase(createWorkshopService.pending, (state) => {
        state.isLoadingAction = true;
      });
  },
});

// Reducer
export default slice.reducer;

// Actions
// export const { } = slice.actions;
